import appIcon from 'assets/icon-app.png';
import { Button } from 'components';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { useTreatmentInQueue } from 'hooks/useTreatmentInQueue';
import { FC } from 'react';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Breadcrumbs, Divider, Grid, Typography } from '@mui/material';

import { PetCard } from './PetCard';
import { PetTreatmentInformations } from 'components/molecules/pet/PetTreatmentInformations';
import { IPet } from 'types/Pet';
import { PetSymptoms } from 'components/molecules/pet/PetSymptoms';

export const Appointment: FC = () => {
  const {
    pet,
    petSymptoms,
    generalClassification,
    handleGoBack,
    acceptTreatment,
    loading,
  } = useTreatmentInQueue();

  if (!pet?.tutor || !pet._id) {
    return null;
  }

  return (
    <Grid container spacing={3}>
      <Grid container item spacing={2}>
        <Grid item xs={12}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" color="disabled" />}
          >
            <Typography fontSize={14} fontWeight={400}>
              Painel de Atendimentos
            </Typography>
            <Typography fontSize={14} fontWeight={400} color="#4B4B4B">
              Pré Atendimento
            </Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.1)', height: 1 }} />
        </Grid>
      </Grid>

      <Grid container item marginTop={2}>
        <PaperCardTemplate>
          <Grid
            container
            spacing={2}
            marginBottom={4}
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
          >
            <Grid item xs="auto">
              <Typography
                display={'flex'}
                justifyContent="space-between"
                alignItems="center"
                sx={{ fontWeight: 400, fontSize: 18, pr: 2 }}
              >
                DADOS DO PET
              </Typography>
            </Grid>
            <Grid item xs>
              <Divider sx={{ borderColor: '#FBB45F', height: 1 }} />
            </Grid>
          </Grid>
          <Box display="flex" mb={2}>
            <PetCard image={pet.imageUrl || appIcon} />
            <PetTreatmentInformations
              ml={4}
              pet={pet as unknown as IPet}
              tutorName={pet?.tutor?.name}
              planName={pet?.tutor?.company ? pet?.tutor?.company.companyName : 'Vet4One'}
            />
          </Box>
        </PaperCardTemplate>
      </Grid>

      {generalClassification !== null && (
        <Grid item xs={12} md={12} mt={1}>
          <Grid
            container
            spacing={2}
            marginBottom={4}
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
          >
            <Grid item xs="auto">
              <Typography
                display={'flex'}
                justifyContent="space-between"
                alignItems="center"
                sx={{ fontWeight: 400, fontSize: 18, pr: 2 }}
              >
                CLASSIFICAÇÃO DE RISCO
              </Typography>
            </Grid>
            <Grid item xs>
              <Divider sx={{ borderColor: '#FBB45F', height: 1 }} />
            </Grid>
          </Grid>

          <PetSymptoms
            symptoms={petSymptoms}
            generalClassification={generalClassification}
          />
        </Grid>
      )}

      <Grid
        item
        container
        mt={2}
        md={12}
        sm={12}
        alignItems="flex-end"
        justifyContent="flex-end"
      >
        <Button onClick={handleGoBack}>VOLTAR</Button>

        <Button
          loading={loading}
          disabled={loading}
          onClick={acceptTreatment}
          sx={{ ml: 2 }}
        >
          REALIZAR CHAMADA
        </Button>
      </Grid>
    </Grid>
  );
};
